export default function () {
  // if we are on portal.x.dev.nelson.services, strip to x.dev.nelson.services
  return (
    process.env.REACT_APP_CONTRACTOR_PORTAL_HOST ||
    window.location.protocol +
      "//contractor-portal." +
      window.location.hostname.split(".").slice(1).join(".")
  );
}
